/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SectionAnswerDto } from './SectionAnswerDto';
import {
    SectionAnswerDtoFromJSON,
    SectionAnswerDtoFromJSONTyped,
    SectionAnswerDtoToJSON,
} from './SectionAnswerDto';

/**
 * 
 * @export
 * @interface SaveAnswersRequest
 */
export interface SaveAnswersRequest {
    /**
     * 
     * @type {Array<SectionAnswerDto>}
     * @memberof SaveAnswersRequest
     */
    answers?: Array<SectionAnswerDto>;
    /**
     * 
     * @type {string}
     * @memberof SaveAnswersRequest
     */
    operatorId?: string;
}

/**
 * Check if a given object implements the SaveAnswersRequest interface.
 */
export function instanceOfSaveAnswersRequest(value: object): value is SaveAnswersRequest {
    return true;
}

export function SaveAnswersRequestFromJSON(json: any): SaveAnswersRequest {
    return SaveAnswersRequestFromJSONTyped(json, false);
}

export function SaveAnswersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAnswersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'answers': json['answers'] == null ? undefined : ((json['answers'] as Array<any>).map(SectionAnswerDtoFromJSON)),
        'operatorId': json['operatorId'] == null ? undefined : json['operatorId'],
    };
}

export function SaveAnswersRequestToJSON(value?: SaveAnswersRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'answers': value['answers'] == null ? undefined : ((value['answers'] as Array<any>).map(SectionAnswerDtoToJSON)),
        'operatorId': value['operatorId'],
    };
}

